<template>
    <div class="sniper-container" >
      <div class="sniper-card">
        <div class="header">
          <div class="w-11">
            <img :src="imgPath" :title="header" :class="iconClass" />
          </div>
          <div class="w-75" style="padding-left: 0.5rem">
            <div class="row">
                <div class="column">
                    <span class="title">{{imgText.charAt(0).toUpperCase() + imgText.slice(1) }}: Top Candidates</span>
                    <a href="/help/knowledgebase?section=rcmnd-prfls" target="_blank">
                        <img src="/img/icons/ic_info.svg" title="About Recommended Profiles" class="ms-2"/>
                    </a>
                </div>
            </div>
            <p class="sub-title">Based on wellness data</p>
          </div>
          <div class="w-14" style="min-width: 14%">
            <div style="float: right;">
              <router-link
                    target="_blank"
                    :to="{
                        name: `Top Profiles`,
                    }"
                    exact>
                    <div class="row">
                        <button type="button" class="btn btn-outline-light more-button" style="padding: 0.1rem;width: 5rem;">
                            <span class="more-label">More</span>
                            <IconArrowRight></IconArrowRight>
                        </button>
                    </div>
            </router-link>
            </div>
           </div>
        </div>
  
        <div class="candidates">
          <div 
            v-for="(candidate, index) in candidates" 
            :key="index" class="candidate" 
            :class="{ 'div-separator': index > 0 == true }"
            style="max-width: 16.5%;min-width: 16.5%;"
            >
            <div :class="{ 'padding-left': index > 0, 'padding-right': index < candidates.length -1}">
                <div class="name-section">
                    <div class="row wd-100 candidate-details" @click="redirectToUser(`User`, { udid: candidate.udid}, { date: getDate()})">
                        <label 
                          class="candidate-name label-name col" 
                          style="cursor: pointer;"
                          :title="candidate.user[0].name"
                          >
                            {{ candidate.user[0].name }}</label>
                        <div class="col" style="max-width:17%">
                          <icon-open-in-new-window class="me-1" style="padding-top: 2px;" />
                        </div>
                    </div>
                  <p :title="candidate.user[0].platoon_name" class="text-capitalize text-muted truncate-text">
                    {{candidate.user[0].platoon_name.toUpperCase()}} / {{ candidate.user[0].section_name.toUpperCase() }}</p>
                </div>
                <div class="score-section">
                    <div class="score" style="margin-right:0.5rem;">
                        <span>WELLNESS SCORE</span>
                        <div style="padding-top: 0.25rem;">
                          <img 
                            src="/img/icons/ic_wellness.svg" 
                            title="Wellness icon"
                            style="width: 1.2rem;padding-bottom: 0.25rem;" 
                            />
                          <label class="secondary-score">{{ candidate.wellness_score }}%</label>
                        </div>
                      </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import IconArrowRight from "@/shared/Controls/Icons/IconArrowRight.vue";
  import IconOpenInNewWindow from "@/shared/Controls/Icons/IconOpenInNewWindow.vue";
  import DateUtils from "@/helpers/dateUtils";
  import { useRouter } from "vue-router";

  export default {
    name: "TopWellnessCandidates",
    components: {
        IconArrowRight,
        IconOpenInNewWindow,
    },
    props: {
      header: {
        type: String,
        default: "Top Candidates",
      },
      subHeader: {
        type: String,
        default: "Based on wellness data",
      },
      imgPath: {
        type: String,
        default: "/img/adcda_logo.png",
      },
      imgText: {
        type: String,
        default: "",
      },
      dnaProfileId: {
        type: String,
        required: true,
      },
      selectedDate: {
        type: Object,
        required: true,
      },
      iconClass: {
        type: String,
        default: "image-logo",
      },
  },
  data() {
      return {
        candidates: [],
        router: useRouter(),
      };
  },
  mounted() {
    this.getCandidatesForSelectedProfileType();
  },
  methods: {
    getCandidatesForSelectedProfileType() {
      if (this.dnaProfileId) {
        this.$store
          .dispatch("data/candidatesForProfileType", {
            dna_profile_id: this.dnaProfileId,
            sort: "wellness_score",
            order: "desc",
            page: 1,
            page_size: 6,
            min_confidence: 0,
            max_confidence: 100,
            search_term: "",
            platoon_id: -1,
            section_id: -1,
          })
          .then(({ data }) => {
            if (data && data.count > 0) {
              this.candidates = data.rows;
            }
          });
      }
    },
    getDate() {
     return DateUtils.formatDateToBucketDate(this.selectedDate)
    },
    redirectToUser(path, paramsDetails, queryDetails) {
      const routeData = this.router.resolve({name: path, params: paramsDetails, query: queryDetails});
      window.open(routeData.href, '_blank');
    },
  },  
  };
  </script>
  
  <style lang="scss" scoped>
  .sniper-container {
    background-color: #283335;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.5rem;
    padding-top: 0.65rem;
    padding-bottom: 0.65rem;
  }
  
  .sniper-card {
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
  
  .header {
    display: flex;
  }
  
  .image-logo {
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 50%;
  }

  .client-icon {
    border-radius: 1rem;
    background: #F0D05F;
    padding: 0.5rem;
    border-bottom-style: solid;
    border-bottom-color: #A0352b;
    border-bottom-width: 0.5rem;
  }

   .size-icon {
    max-width: 7rem;
    max-height: 7rem;
  }
  
  .title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 500;
  }
  
  .sub-title {
    margin: 0;
    font-size: 1rem;
    color: #9aa1a8;
  }
  
  .candidates {
    display: flex;
    justify-content: flex-start;
    margin-top: 1rem;
  }
  .div-separator {
    border-left: 0.1rem solid #4e5155;
    border-width: thin;
  }
  .candidate {
    display: flex;
    flex-direction: column;
  }
  
  .candidate-name {
    font-size: 1rem;
    color: #359685;
    padding-right:1rem;
    font-weight: 600;
  }

  .candidate-details {
    cursor: pointer;
  }

  .name-section h4 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 500;
    width: 12rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .name-section p {
    margin: 0;
    font-size: 0.8rem;
    color: #9aa1a8;
  }
  .score-section h2 {
    margin-top: 0.5rem;
    font-size: 1.25rem;
    font-weight: 400;
  }
  
  .score-details {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  .score {
    display: flex;
    flex-direction: column;
  }

  .secondary-score {
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: 0rem;
    margin-top: 0rem;
  }
  
  .score span {
    font-size: 0.7rem;
    color: #9aa1a8;
  }
  
  .score strong {
    font-size: 0.9rem;
    font-weight: 500;
  }
  .more-button {
    height: 2.5rem;
    margin-bottom: 0rem;
    border-style: groove;
    align-items: center;
    border-color: #9aa1a8;
    border-width: thin;
    cursor: pointer;
  }
  .more-label {
    padding-right: 0.3rem;
    font-weight: 100;
    font-size: 0.8rem;
  }
  .padding-left {
    padding-left: 0.5rem;
  }
  .padding-right {
    padding-right: 0.5rem;
  }
  .truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .label-name {
    min-width: 74%;
    color: #359685 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
    padding-right:0;
  }
  </style>
  